<template>
  <div>
    <ConfirmOrder @edit-order="editOrder" />
  </div>
</template>
<script>
import ConfirmOrder from "../../components/Client/ConfirmOrder.vue";
export default {
  components: { ConfirmOrder },
  methods: {
    editOrder() {
      location.href = "/";
    },
  },
};
</script>
